import { Alert } from 'shared/mui/Alert/Alert';

type ExpenseReportListAccessAlertProps = {
  firstName: string;
  lastName: string;
};

export const ExpenseReportListAccessAlert = ({
  firstName,
  lastName,
}: ExpenseReportListAccessAlertProps) => (
  <Alert severity="warning" sx={{ marginBottom: '8px' }}>
    {`Для пользователя ${firstName} ${lastName} не настроена "Рабочая группа" и "Личные кабинеты", обратитесь к руководителю вашего подразделения для настроек доступа`}
  </Alert>
);
